/* Bumpers club popup: side tab, sign-up dialog, success view, coupon bar. Vanilla JS. */
(function () {
  'use strict';
  if (window.__bumpersPopupLoaded) return;
  window.__bumpersPopupLoaded = true;

  var KEY_SUBSCRIBED = 'bumpers_popup_subscribed';
  var KEY_BAR_CLOSED = 'bumpers_popup_bar_closed';
  var KEY_SNOOZE = 'bumpers_popup_snooze_until';
  var KEY_TAB_HIDDEN = 'bumpers_popup_tab_hidden';
  var KEY_VID = 'bumpers_popup_vid';
  var OPEN_HASHES = ['#bumpers-popup-open', '#Ecomsend_popups_open_200943'];

  // Storage can throw (private mode, blocked site data): fall back to no memory.
  function store(kind) {
    return {
      get: function (k) { try { return window[kind].getItem(k); } catch (e) { return null; } },
      set: function (k, v) { try { window[kind].setItem(k, v); } catch (e) {} }
    };
  }
  var local = store('localStorage');
  var session = store('sessionStorage');

  function device() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop';
  }

  function track(name, params) {
    params = params || {};
    params.device = params.device || device();
    try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish(name, params); } catch (e) {}
    try { window.dataLayer && window.dataLayer.push(Object.assign({ event: name }, params)); } catch (e) {}
    try { typeof window.gtag === 'function' && window.gtag('event', name, params); } catch (e) {}
  }

  // Anonymous visitor id for the popup-analytics dashboard (no personal data).
  var memVid = null;
  function visitorId() {
    var v = local.get(KEY_VID);
    if (!v) {
      v = memVid || (Date.now().toString(36) + Math.random().toString(36).slice(2, 12));
      local.set(KEY_VID, v);
      memVid = v;
    }
    return v;
  }

  // Fire-and-forget event to the Cloudflare worker. text/plain keeps it a "simple" request (no preflight).
  function beacon(cfg, event, trigger) {
    if (!cfg || !cfg.analyticsUrl || cfg.designMode) return;
    try {
      var body = JSON.stringify({
        shop: cfg.shop || '',
        version: cfg.version || '',
        event: event,
        device: device(),
        trigger: trigger || '',
        page_type: cfg.pageType || '',
        visitor_id: visitorId(),
        ts: Date.now()
      });
      var sent = false;
      if (navigator.sendBeacon) {
        try { sent = navigator.sendBeacon(cfg.analyticsUrl, new Blob([body], { type: 'text/plain' })); } catch (e) {}
      }
      if (!sent && window.fetch) {
        fetch(cfg.analyticsUrl, { method: 'POST', body: body, keepalive: true, mode: 'no-cors', headers: { 'Content-Type': 'text/plain' } }).catch(function () {});
      }
    } catch (e) {}
  }

  var current = null; // the live popup instance (re-created when the theme editor reloads the section)

  function Popup(root) {
    this.root = root;
    try { this.cfg = JSON.parse(root.querySelector('[data-bp-config]').textContent); } catch (e) { this.cfg = {}; }
    this.overlay = root.querySelector('[data-bp-overlay]');
    this.box = root.querySelector('.bp-box');
    this.form = root.querySelector('form.bp-form');
    this.tab = root.querySelector('[data-bp-tab]');
    this.trigger = null;
    this.isOpen = false;
    this.subscribedNow = false;
    this.mountBar();
    this.bind();
    this.applyState();
    this.maybeAutoOpen();
  }

  Popup.prototype.isSubscribed = function () {
    if (this.cfg.designMode) return false;
    if (this.cfg.serverSubscribed) return true;
    // stored value = sign-up time (ms); it expires after "hideAfterSignupDays" so the popup comes back a year later
    var at = parseInt(local.get(KEY_SUBSCRIBED), 10) || 0;
    var days = parseInt(this.cfg.hideAfterSignupDays, 10) || 365;
    return at > 1 && Date.now() - at < days * 864e5;
  };

  // The bar has to sit above the header, so it is moved to the very top of <body>.
  Popup.prototype.mountBar = function () {
    var old = document.querySelectorAll('body > #BumpersPopupBar');
    for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);
    this.bar = this.root.querySelector('#BumpersPopupBar');
    if (this.bar) document.body.insertBefore(this.bar, document.body.firstChild);
  };

  Popup.prototype.applyState = function () {
    var subscribed = this.isSubscribed();
    if (this.tab) {
      var tabHidden = !this.cfg.designMode && session.get(KEY_TAB_HIDDEN) === '1';
      this.tab.hidden = !this.cfg.tabEnabled || subscribed || tabHidden || this.subscribedNow;
    }
    // a code is already applied (e.g. the survey voucher via /discount/...), so a reminder for the club code would only confuse
    var codeApplied = /(?:^|;\s*)discount_code=[^;]+/.test(document.cookie);
    this.setBar(this.cfg.barEnabled && (subscribed || this.subscribedNow) && !codeApplied && local.get(KEY_BAR_CLOSED) !== '1');
  };

  Popup.prototype.setBar = function (show) {
    if (!this.bar) return;
    this.bar.hidden = !show;
    var html = document.documentElement;
    if (show) {
      html.classList.add('bp-bar-on');
      html.style.setProperty('--bp-bar-h', this.bar.offsetHeight + 'px');
    } else {
      html.classList.remove('bp-bar-on');
      html.style.removeProperty('--bp-bar-h');
    }
  };

  Popup.prototype.maybeAutoOpen = function () {
    var self = this;
    var sec = parseInt(this.cfg.autoOpenSec, 10) || 0;
    if (!this.cfg.enabled || this.cfg.designMode || sec <= 0 || this.isSubscribed()) return;
    var until = parseInt(local.get(KEY_SNOOZE), 10) || 0;
    if (until && Date.now() < until) return;
    this.autoTimer = setTimeout(function () {
      if (!self.isOpen) {
        self.snooze();
        self.open('auto');
      }
    }, sec * 1000);
  };

  Popup.prototype.snooze = function () {
    var days = parseInt(this.cfg.reshowDays, 10) || 14;
    local.set(KEY_SNOOZE, String(Date.now() + days * 864e5));
  };

  Popup.prototype.bind = function () {
    var self = this;
    var root = this.root;

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-bp-open],[data-bp-close],[data-bp-tab-close],[data-bp-copy]');
      if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-bp-open')) {
        track('bumpers_popup_sidebar_click', { trigger: 'sidebar' });
        self.open('sidebar');
      } else if (t.hasAttribute('data-bp-close')) {
        self.close();
      } else if (t.hasAttribute('data-bp-tab-close')) {
        session.set(KEY_TAB_HIDDEN, '1');
        if (self.tab) self.tab.hidden = true;
      } else if (t.hasAttribute('data-bp-copy')) {
        self.copy(t);
      }
    });

    if (this.overlay) {
      this.overlay.addEventListener('mousedown', function (e) {
        if (e.target === self.overlay) self.close();
      });
    }

    if (this.bar) {
      this.bar.addEventListener('click', function (e) {
        var t = e.target.closest('[data-bp-copy],[data-bp-bar-close]');
        if (!t) return;
        if (t.hasAttribute('data-bp-copy')) self.copy(t);
        else {
          local.set(KEY_BAR_CLOSED, '1');
          self.setBar(false);
        }
      });
    }

    if (this.form) {
      this.form.addEventListener('submit', function (e) {
        e.preventDefault();
        self.submit();
      });
      // digits only in the birthday boxes, and hop to the next box when full
      var bd = this.form.querySelectorAll('.bp-bd .bp-input');
      for (var i = 0; i < bd.length; i++) {
        bd[i].addEventListener('input', function () {
          this.value = this.value.replace(/\D/g, '');
          var next = this.nextElementSibling;
          if (next && this.value.length >= parseInt(this.getAttribute('maxlength'), 10)) next.focus();
        });
      }
      // calendar picker fills the three boxes
      var cal = this.form.querySelector('[data-bp-cal]');
      if (cal) {
        try { cal.max = new Date().toISOString().slice(0, 10); } catch (e) {}
        cal.addEventListener('click', function () {
          try { if (typeof cal.showPicker === 'function') cal.showPicker(); } catch (e) {}
        });
        cal.addEventListener('change', function () {
          var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(cal.value || '');
          if (!m) return;
          var y = self.input('year'), mo = self.input('month'), d = self.input('day');
          if (y) y.value = m[1];
          if (mo) mo.value = String(parseInt(m[2], 10));
          if (d) d.value = String(parseInt(m[3], 10));
          self.clearError('date');
        });
      }
      this.form.addEventListener('input', function (e) {
        var name = e.target.getAttribute('data-bp-input');
        if (!name) return;
        var key = name === 'day' || name === 'month' || name === 'year' ? 'date' : name;
        self.clearError(key);
      });
    }
  };

  Popup.prototype.showView = function (name) {
    var views = this.root.querySelectorAll('[data-bp-view]');
    for (var i = 0; i < views.length; i++) views[i].hidden = views[i].getAttribute('data-bp-view') !== name;
  };

  Popup.prototype.open = function (trigger, view) {
    if (!this.overlay) return;
    var self = this;
    clearTimeout(this.autoTimer);
    this.trigger = trigger || 'link';
    this.lastFocus = document.activeElement;
    this.showView(view || (this.subscribedNow ? 'success' : 'form'));
    this.overlay.hidden = false;
    this.isOpen = true;
    document.documentElement.classList.add('bp-lock');
    requestAnimationFrame(function () {
      self.overlay.classList.add('is-open');
      self.box.scrollTop = 0;
      self.box.focus({ preventScroll: true });
    });
    if ((view || 'form') === 'form' && !this.cfg.designMode) {
      track('bumpers_popup_view', { trigger: this.trigger });
      beacon(this.cfg, 'view', this.trigger);
    }
  };

  Popup.prototype.close = function (silent) {
    if (!this.isOpen) return;
    var self = this;
    this.isOpen = false;
    this.overlay.classList.remove('is-open');
    document.documentElement.classList.remove('bp-lock');
    setTimeout(function () { if (!self.isOpen) self.overlay.hidden = true; }, 200);
    if (!silent && !this.subscribedNow && !this.cfg.designMode) {
      this.snooze();
      track('bumpers_popup_close', { trigger: this.trigger });
      beacon(this.cfg, 'close', this.trigger);
    }
    if (this.lastFocus && this.lastFocus.focus) {
      try { this.lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
  };

  Popup.prototype.copy = function (btn) {
    var code = this.cfg.code || '';
    var done = function () {
      btn.classList.add('is-copied');
      setTimeout(function () { btn.classList.remove('is-copied'); }, 1500);
    };
    var fallback = function () {
      var ta = document.createElement('textarea');
      ta.value = code;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;top:-100px;opacity:0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      done();
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, fallback);
    else fallback();
    track('bumpers_popup_copy_code', { trigger: btn.getAttribute('data-bp-copy') });
  };

  /* ---------- validation ---------- */
  Popup.prototype.input = function (name) {
    return this.form ? this.form.querySelector('[data-bp-input="' + name + '"]') : null;
  };

  Popup.prototype.setError = function (key, text) {
    var p = this.root.querySelector('[data-bp-err="' + key + '"]');
    if (p) { p.textContent = text; p.hidden = false; }
    var names = key === 'date' ? ['day', 'month', 'year'] : [key];
    for (var i = 0; i < names.length; i++) {
      var el = this.input(names[i]);
      if (el) { el.classList.add('is-invalid'); el.setAttribute('aria-invalid', 'true'); }
    }
  };

  Popup.prototype.clearError = function (key) {
    var p = this.root.querySelector('[data-bp-err="' + key + '"]');
    if (p) { p.hidden = true; p.textContent = ''; }
    var names = key === 'date' ? ['day', 'month', 'year'] : [key];
    for (var i = 0; i < names.length; i++) {
      var el = this.input(names[i]);
      if (el) { el.classList.remove('is-invalid'); el.removeAttribute('aria-invalid'); }
    }
  };

  // Israeli numbers only: strip spaces/dashes, a leading 972 and a leading 0.
  // 9 digits must be a mobile (5X...), 8 digits is a landline.
  function normalizePhone(raw) {
    var d = String(raw || '').replace(/\D/g, '');
    if (d.indexOf('972') === 0) d = d.slice(3);
    d = d.replace(/^0+/, '');
    if (d.length === 9 && d.charAt(0) === '5') return '+972' + d;
    if (d.length === 8 && /^[2-489]/.test(d)) return '+972' + d;
    return null;
  }

  function birthday(dd, mm, yy) {
    var d = parseInt(dd, 10), m = parseInt(mm, 10), y = parseInt(yy, 10);
    var nowY = new Date().getFullYear();
    if (!d || !m || !y || String(yy).length !== 4 || y < 1900 || y > nowY) return null;
    var dt = new Date(Date.UTC(y, m - 1, d));
    if (dt.getUTCFullYear() !== y || dt.getUTCMonth() !== m - 1 || dt.getUTCDate() !== d) return null;
    return y + '-' + (m < 10 ? '0' : '') + m + '-' + (d < 10 ? '0' : '') + d;
  }

  Popup.prototype.validate = function () {
    var f = this.cfg.fields || {};
    var msg = this.cfg.msg || {};
    var REQ = msg.required || 'חובה*';
    var out = { ok: true, phone: null, birthday: null, consent: false, email: '', name: '' };
    var firstBad = null;
    var self = this;
    // empty required field → "חובה*"; filled but wrong → the specific message
    var fail = function (key, el, text) { out.ok = false; self.setError(key, text); if (!firstBad) firstBad = el; };

    ['name', 'phone', 'email', 'date', 'consent', 'form'].forEach(this.clearError, this);

    var name = this.input('name');
    if (name) {
      out.name = name.value.trim();
      if (!out.name) { if (f.name && f.name.required) fail('name', name, REQ); }
      else if (out.name.length < 2) fail('name', name, msg.name || REQ);
    }

    var phone = this.input('phone');
    if (phone) {
      if (!phone.value.trim()) { if (f.phone && f.phone.required) fail('phone', phone, REQ); }
      else {
        out.phone = normalizePhone(phone.value);
        if (!out.phone) fail('phone', phone, msg.phone || REQ);
      }
    }

    var email = this.input('email');
    out.email = email ? email.value.trim() : '';
    if (!out.email) fail('email', email, REQ);
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(out.email)) fail('email', email, msg.email || REQ);

    var day = this.input('day');
    if (day) {
      var month = this.input('month'), year = this.input('year');
      var any = day.value || month.value || year.value;
      if (!any) { if (f.birthday && f.birthday.required) fail('date', year, REQ); }
      else {
        out.birthday = birthday(day.value, month.value, year.value);
        if (!out.birthday) fail('date', year, msg.date || REQ);
      }
    }

    var consent = this.input('consent');
    if (consent) {
      out.consent = !!consent.checked;
      if (!out.consent) fail('consent', consent, msg.consent || REQ);
    }

    if (firstBad) { try { firstBad.focus(); } catch (e) {} }
    return out;
  };

  /* ---------- submit (native customer form, posted in the background) ---------- */
  Popup.prototype.submit = function () {
    if (this.busy) return;
    var self = this;
    var v = this.validate();
    if (!v.ok) return;

    var tags = String(this.cfg.baseTags || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
    if (v.birthday) tags.push('birthday:' + v.birthday);
    var g = this.form.querySelector('[data-bp-gender]:checked');
    if (g) tags.push('gender:' + g.value);
    // Shopify's customer form drops contact[phone], so the number travels as a tag
    if (v.phone) tags.push('phone:' + v.phone);
    // tells the Shopify Flow it may fill the phone field and open SMS consent
    if (v.consent && this.cfg.consentTag) tags.push(this.cfg.consentTag);
    this.form.querySelector('[data-bp-tags]').value = tags.join(', ');

    var full = this.form.querySelector('[data-bp-phone-full]');
    if (full) {
      full.value = v.phone || '';
      full.disabled = !v.phone;
    }

    var btn = this.form.querySelector('[data-bp-submit]');
    this.busy = true;
    btn.disabled = true;
    btn.classList.add('is-loading');

    var action = (this.form.getAttribute('action') || '/contact').split('#')[0];
    var data = new FormData(this.form);

    fetch(action, { method: 'POST', body: data, credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (res) {
        if (/\/challenge/.test(res.url)) return { ok: false, reason: 'challenge' };
        if (/customer_posted=true/.test(res.url)) return { ok: true };
        return res.text().then(function (html) {
          var m = html.match(/<template data-bp-form-error>([\s\S]*?)<\/template>/);
          if (m) {
            var err = m[1].replace(/<[^>]+>/g, ' ').trim();
            // an existing address is still a successful sign-up from the visitor's point of view
            if (/taken|already|exists|קיים|כבר/i.test(err)) return { ok: true, existing: true };
            return { ok: false, reason: err };
          }
          return { ok: res.ok };
        });
      })
      .then(function (r) {
        self.recordSignup(v, r.ok ? (r.existing ? 'existing' : 'ok') : (r.reason === 'challenge' ? 'challenge' : 'error'));
        if (r.ok) self.success();
        else {
          if (r.reason === 'challenge' && window.console) console.warn('[bumpers-popup] Shopify asked for a captcha challenge');
          self.setError('form', (self.cfg.msg || {}).send || '');
        }
      })
      .catch(function () {
        self.recordSignup(v, 'network');
        self.setError('form', (self.cfg.msg || {}).send || '');
      })
      .then(function () {
        self.busy = false;
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  };

  // Legal record of the sign-up (the worker adds IP and User-Agent from the request itself).
  Popup.prototype.recordSignup = function (v, result) {
    var cfg = this.cfg;
    if (!cfg.analyticsUrl || cfg.designMode) return;
    var url = String(cfg.analyticsUrl).replace(/\/e\/?$/, '/signup');
    var textEl = this.root.querySelector('[data-bp-consent-text]');
    try {
      var body = JSON.stringify({
        shop: cfg.shop || '',
        version: cfg.version || '',
        email: v.email,
        name: v.name,
        phone: v.phone || '',
        birthday: v.birthday || '',
        gender: (function (c) { return c ? c.value : ''; })(this.form && this.form.querySelector('[data-bp-gender]:checked')),
        consent_text: textEl ? textEl.textContent.trim() : '',
        consent_checked: !!v.consent,
        page_url: location.href.split('#')[0],
        shopify_result: result,
        visitor_id: visitorId()
      });
      fetch(url, { method: 'POST', body: body, keepalive: true, credentials: 'omit', headers: { 'Content-Type': 'text/plain' } }).catch(function () {});
    } catch (e) {}
  };

  Popup.prototype.success = function () {
    this.subscribedNow = true;
    local.set(KEY_SUBSCRIBED, String(Date.now()));
    track('bumpers_popup_submit', { trigger: this.trigger || 'link' });
    beacon(this.cfg, 'submit', this.trigger || 'link');
    try { if (typeof window.fbq === 'function') window.fbq('track', 'Lead', { content_name: 'popup-club5' }); } catch (e) {}
    this.showView('success');
    this.box.scrollTop = 0;
    this.applyState();
  };

  /* ---------- editor preview ---------- */
  Popup.prototype.editorShow = function () {
    var view = this.cfg.editorView;
    if (view === 'bar') { this.close(true); this.setBar(true); return; }
    this.setBar(false);
    if (view === 'none') { this.close(true); return; }
    this.open('editor', view === 'success' ? 'success' : 'form');
  };

  Popup.prototype.destroy = function () {
    clearTimeout(this.autoTimer);
    this.close(true);
    this.setBar(false);
    if (this.bar && this.bar.parentNode) this.bar.parentNode.removeChild(this.bar);
  };

  /* ---------- global wiring (registered once) ---------- */
  function linkHash(a) {
    var href = a.getAttribute('href') || '';
    var i = href.indexOf('#');
    return i === -1 ? '' : href.slice(i);
  }

  document.addEventListener('click', function (e) {
    if (!current) return;
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a || OPEN_HASHES.indexOf(linkHash(a)) === -1) return;
    e.preventDefault();
    current.open('link');
  });

  // The newsletter form at the bottom of the site posts natively (page reload), so its sign-up record
  // goes out as a beacon on submit, with the wording shown around the form.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!current || !form || !form.matches || !form.matches('form.newsletter-form, form#ContactFooter')) return;
    if (form.closest('#BumpersPopup')) return;
    var cfg = current.cfg;
    if (!cfg.analyticsUrl || cfg.designMode || !navigator.sendBeacon) return;
    var emailEl = form.querySelector('input[type="email"]');
    var email = emailEl ? emailEl.value.trim() : '';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return;
    var box = form.querySelector('[data-nl-consent]');
    if (box && !box.checked) return; // the newsletter section blocks this submit itself
    var labelEl = form.querySelector('[data-nl-consent-text]');
    var section = form.closest('.shopify-section') || form.parentNode;
    var text = labelEl ? labelEl.textContent.replace(/\s+/g, ' ').trim() : '';
    if (!text) try {
      var clone = section.cloneNode(true);
      var forms = clone.querySelectorAll('form, script, style');
      for (var i = 0; i < forms.length; i++) forms[i].parentNode.removeChild(forms[i]);
      // keep line breaks between headings / paragraphs as spaces
      var brs = clone.querySelectorAll('br');
      for (var b = 0; b < brs.length; b++) brs[b].parentNode.replaceChild(document.createTextNode(' '), brs[b]);
      var blocks = clone.querySelectorAll('p, div, li, h1, h2, h3, h4, h5, h6');
      for (var k = 0; k < blocks.length; k++) blocks[k].appendChild(document.createTextNode(' '));
      text = (clone.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 600);
    } catch (err) {}
    try {
      var body = JSON.stringify({
        shop: cfg.shop || '',
        version: cfg.version || '',
        form: 'footer',
        email: email,
        consent_text: text,
        consent_checked: !!(box && box.checked),
        page_url: location.href.split('#')[0],
        shopify_result: 'native',
        visitor_id: visitorId()
      });
      navigator.sendBeacon(String(cfg.analyticsUrl).replace(/\/e\/?$/, '/signup'), new Blob([body], { type: 'text/plain' }));
    } catch (err) {}
  }, true);

  document.addEventListener('keydown', function (e) {
    if (current && current.isOpen && (e.key === 'Escape' || e.key === 'Esc')) current.close();
  });

  function init() {
    var root = document.getElementById('BumpersPopup');
    if (!root) return;
    if (current) current.destroy();
    current = new Popup(root);
    if (OPEN_HASHES.indexOf(location.hash) !== -1) current.open('link');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector && e.target.querySelector('#BumpersPopup')) {
      init();
      if (current && current.cfg.designMode) current.editorShow();
    }
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (current && e.target.contains(current.root)) { current.destroy(); current = null; }
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (current && e.target.contains(current.root)) current.editorShow();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (current && e.target.contains(current.root)) { current.close(true); current.applyState(); }
  });
})();
